export const createProjectMutation = /* GraphQL */ `
  mutation CreateProject($input: CreateProjectInput!, $condition: ModelProjectConditionInput) {
    createProject(input: $input, condition: $condition) {
      createdAt
      icon
      id
      itemsCount
      name
      owner
      updatedAt
      visibility
      visibilityGroup
    }
  }
`;

export const updateProjectMutation = /* GraphQL */ `
  mutation UpdateProject($input: UpdateProjectInput!, $condition: ModelProjectConditionInput) {
    updateProject(input: $input, condition: $condition) {
      createdAt
      icon
      id
      itemsCount
      name
      owner
      updatedAt
      visibility
      visibilityGroup
    }
  }
`;

export const deleteProjectMutation = /* GraphQL */ `
  mutation DeleteProject($input: DeleteProjectInput!, $condition: ModelProjectConditionInput) {
    deleteProject(input: $input, condition: $condition) {
      createdAt
      icon
      id
      itemsCount
      name
      owner
      updatedAt
      visibility
      visibilityGroup
    }
  }
`;

export const updateLikieeProjects = /* GraphQL */ `
  mutation updateLikieeProjects($likieeID: ID!, $projectIDs: [ID!]!) {
    updateLikieeProjects(likieeID: $likieeID, projectIDs: $projectIDs) {
      success
    }
  }
`;

export const addLikieeToProject = /* GraphQL */ `
  mutation addLikieeToProject($likieeID: ID!, $projectID: ID!) {
    addLikieeToProject(likieeID: $likieeID, projectID: $projectID) {
      error
      success
    }
  }
`;

export const removeLikieeFromProject = /* GraphQL */ `
  mutation removeLikieeFromProject($likieeID: ID!, $projectID: ID!) {
    removeLikieeFromProject(likieeID: $likieeID, projectID: $projectID) {
      error
      success
    }
  }
`;

export const addLikieesToProjects = /* GraphQL */ `
  mutation addLikieesToProjects($likieeIDs: [ID!], $projectIDs: [ID!]) {
    addLikieesToProjects(likieeIDs: $likieeIDs, projectIDs: $projectIDs) {
      error
      success
    }
  }
`;
